<template>
    <li
        class="list-group-item"
        @click.stop="goTo(item.path)"
    >
        {{ item.name }}{{ identifier }}
        <img
            src="@/assets/svg/plus-ffffff.svg"
            v-if="item.addLink"
            @click.stop="add(item.addLink)"
        />
        <test-navigation-list
            v-if="hasChildren"
            :items="item.children"
            :level="level"
            :showLevel="showLevel"
            :index="index"
            @next-level="emitNextLevel"
            :style="isVisible"
        ></test-navigation-list>
    </li>
</template>

<script>
export default {
  data () {
    return {
      showThis: null
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      default: 0,
      type: Number,
      required: true
    },
    index: {
      type: String | Number,
      required: true
    },
    showLevel: {
      default: null,
      type: String | Number,
      required: true
    }
  },
  computed: {
    identifier () {
      return this.index
    },
    hasChildren () {
      return this.item.children && this.item.children.length
    },
    isVisible () {
      return { visibility: (this.identifier === this.showLevel) ? 'visible' : 'hidden' }
    }
  },
  methods: {
    emitNextLevel: function (nextLevel) {
      this.$emit('next-level', nextLevel)
    },
    goTo (path) {
      this.$router.push({ path: path })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test/NavigationListItem.vue